import { initializeApp } from 'firebase/app';
import 'firebase/auth';
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import {
  getMessaging,
  isSupported as isMessagingSupported,
} from 'firebase/messaging';
import { getAnalytics } from 'firebase/analytics';

import {
  initializeFirestore,
  persistentMultipleTabManager,
  tabManager,
  persistentLocalCache,
  connectFirestoreEmulator,
} from 'firebase/firestore';

// Local development against the Firebase emulators (functions/README):
// REACT_APP_FIREBASE_EMULATORS=true npm start. Never set in production builds.
export const useEmulators = process.env.REACT_APP_FIREBASE_EMULATORS === 'true';

const prodConfig = {
  apiKey: 'AIzaSyCt1krur7RzJ_5bMuqv0AUFLwGGNM_dOI4',
  authDomain: 'baws-389800.firebaseapp.com',
  projectId: 'baws-389800',
  storageBucket: 'baws-389800.appspot.com',
  messagingSenderId: '644488033982',
  appId: '1:644488033982:web:23a3842a910f83d8d950ef',
  measurementId: 'G-F638WGHNCT',
};

const firebaseConfig = useEmulators
  ? {
      ...prodConfig,
      projectId: 'demo-baws',
      storageBucket: 'demo-baws.appspot.com',
    }
  : prodConfig;

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export { app };
export const analytics = getAnalytics();
export const auth = getAuth(app);
export const db = initializeFirestore(app, {
  localCache: persistentLocalCache(
    /*settings*/ { tabManager: persistentMultipleTabManager() }
  ),
});

if (useEmulators) {
  connectAuthEmulator(auth, 'http://127.0.0.1:9099', { disableWarnings: true });
  connectFirestoreEmulator(db, '127.0.0.1', 8080);
}

export const isSupported = () =>
  'Notification' in window &&
  'serviceWorker' in navigator &&
  'PushManager' in window;

// notification configs
export let messaging = null;

// Only initialize messaging if supported by the browser/WebView
isMessagingSupported()
  .then((supported) => {
    if (supported) {
      messaging = getMessaging(app);
    } else {
      console.log('Firebase Messaging is not supported in this environment.');
    }
  })
  .catch((err) => {
    console.error('Error checking Firebase Messaging support:', err);
  });
